import { PiPhone } from "react-icons/pi";
import Reveal from "../Reveal";
import { FaWhatsapp } from "react-icons/fa";

export default function CTA() {
  return (
    <section id="cta" className="section !py-20">
      <Reveal>
        <div className="relative rounded-3xl overflow-hidden glass p-10 md:p-16 text-center">
          <div className="absolute inset-0 bg-brand-gradient bg-200 animate-gradient-shift opacity-20" />
          <div className="bg-blob w-64 h-64 bg-teal/50 -bottom-10 -left-10" />
          <div className="bg-blob w-64 h-64 bg-blue/50 -top-10 -right-10" style={{ animationDelay: "1.5s" }} />

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Mulai Transformasi!
            </h2>
            <p className="section-desc text-white mx-auto mb-8">
              Winning the Revolution.
              One Technology Group. One Vision. One Ecosystem.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a href="tel:087872886983" className="btn-primary">
               <PiPhone/> Berbicara dengan Kami 
              </a>
              <a href="https://wa.me/6287872886983?text=Halo,%20saya%20ingin%20diskusi%20dan%20memakai%20services%20dari%20Winrevo" className="btn-secondary transition-all hover:scale-105">
               <FaWhatsapp/>  Konsultatsi melalui WhatsApp
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
